<template>
	<div class="invoice-history">
		<div class="content">
			<!-- Tab切换 -->
			<van-tabs v-model="activeTab" class="invoice-tabs" @change="onTabChange">
				<van-tab title="全部" name="all"></van-tab>
				<van-tab title="正常发票" name="normal"></van-tab>
				<van-tab title="红冲发票" name="red"></van-tab>
			</van-tabs>

			<!-- 搜索筛选区 -->
			<div class="search-section">
				<div class="search-row">
					<div class="search-item">
						<div class="search-label">开始时间</div>
						<van-field
							v-model="startDate"
							readonly
							clickable
							placeholder="请选择"
							right-icon="calendar-o"
							@click="showStartPicker = true"
						/>
					</div>
					<div class="search-item">
						<div class="search-label">结束时间</div>
						<van-field
							v-model="endDate"
							readonly
							clickable
							placeholder="请选择"
							right-icon="calendar-o"
							@click="showEndPicker = true"
						/>
					</div>
				</div>
				<div class="search-row">
					<div class="search-item">
						<div class="search-label">发票状态</div>
						<van-field
							v-model="statusText"
							readonly
							clickable
							placeholder="全部状态"
							right-icon="arrow-down"
							@click="showStatusPicker = true"
						/>
					</div>
				</div>
				<button class="search-btn" @click="onSearch">搜索</button>
			</div>

			<!-- 列表 -->
			<div class="history-list" v-if="filteredList.length > 0">
				<div class="history-item" v-for="(item, index) in filteredList" :key="index">
					<div class="history-header">
						<div class="invoice-title">{{ item.gfmc || '-' }}</div>
						<div class="invoice-status" :class="statusClass(item.orderStatus)">{{ statusLabel(item.orderStatus) }}</div>
						<div class="invoice-type-tag red-tag" v-if="isRedInvoice(item)">红冲</div>
					</div>
					<div class="history-info">
						<div class="info-item">
							<span class="info-label">金额：</span>
							<span class="info-value">¥{{ formatAmount(item.jshj) }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">格式：</span>
							<span class="info-value">PDF</span>
						</div>
						<div class="info-item" v-if="item.gfsh">
							<span class="info-label">税号：</span>
							<span class="info-value">{{ item.gfsh }}</span>
						</div>
						<div class="info-item fail-reason" v-if="item.orderStatus === '3' && item.failReason">
							<span class="info-label">失败原因：</span>
							<span class="info-value">{{ item.failReason }}</span>
						</div>
					</div>
					<div class="history-footer">
						<div class="invoice-date">{{ item.createdDate || '-' }}</div>
						<button
							v-if="shouldShowActionBtn(item)"
							class="action-btn"
							:class="actionBtnClass(item)"
							@click="onAction(item)"
						>{{ actionBtnText(item) }}</button>
					</div>
				</div>
			</div>

			<!-- 空状态 -->
			<div class="empty-state" v-if="loaded && filteredList.length === 0">
				<van-icon name="orders-o" size="60" color="#ccc" />
				<div class="empty-text">暂无开票记录</div>
			</div>

			<!-- 加载中 -->
			<div class="loading-state" v-if="!loaded">
				<van-loading type="spinner" color="#00b5ff">加载中...</van-loading>
			</div>
		</div>

		<!-- 日期选择器 -->
		<van-popup v-model="showStartPicker" position="bottom" round>
			<van-datetime-picker
				type="date"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="onStartConfirm"
				@cancel="showStartPicker = false"
			/>
		</van-popup>
		<van-popup v-model="showEndPicker" position="bottom" round>
			<van-datetime-picker
				type="date"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="onEndConfirm"
				@cancel="showEndPicker = false"
			/>
		</van-popup>

		<!-- 状态选择器 -->
		<van-popup v-model="showStatusPicker" position="bottom" round>
			<van-picker
				:columns="statusColumns"
				@confirm="onStatusConfirm"
				@cancel="showStatusPicker = false"
				show-toolbar
				title="选择发票状态"
			/>
		</van-popup>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeTab: 'all',
			list: [],
			loaded: false,
			startDate: '',
			endDate: '',
			status: '',
			statusText: '',
			showStartPicker: false,
			showEndPicker: false,
			showStatusPicker: false,
			minDate: new Date(2020, 0, 1),
			maxDate: new Date(),
			statusColumns: [
				{ text: '全部状态', value: '' },
				{ text: '已完成', value: '2' },
				{ text: '开具中', value: '1' },
				{ text: '失败', value: '3' }
			]
		}
	},
	computed: {
		filteredList() {
			if (this.activeTab === 'all') return this.list;
			if (this.activeTab === 'normal') return this.list.filter(function(item) { return !item.xsdjbh || item.xsdjbh.indexOf('HC') !== 0; });
			if (this.activeTab === 'red') return this.list.filter(function(item) { return item.xsdjbh && item.xsdjbh.indexOf('HC') === 0; });
			return this.list;
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			var params = {};
			if (this.startDate) params.startDate = this.startDate;
			if (this.endDate) params.endDate = this.endDate;
			if (this.status) params.status = this.status;
			this.$axios.get('/api/v1/wygl/propertyPayment/invoiceHistory', { params: params }).then(function(res) {
				if (res) {
					this.list = Array.isArray(res) ? res : [];
				} else {
					this.list = [];
				}
				this.loaded = true;
			}.bind(this)).catch(function() {
				this.list = [];
				this.loaded = true;
			}.bind(this));
		},
		onSearch() {
			this.loaded = false;
			this.loadData();
		},
		onStartConfirm(val) {
			this.startDate = this.formatDate(val);
			this.showStartPicker = false;
		},
		onEndConfirm(val) {
			this.endDate = this.formatDate(val);
			this.showEndPicker = false;
		},
		onStatusConfirm(val) {
			this.status = val.value;
			this.statusText = val.text;
			this.showStatusPicker = false;
		},
		formatDate(date) {
			var y = date.getFullYear();
			var m = (date.getMonth() + 1).toString().padStart(2, '0');
			var d = date.getDate().toString().padStart(2, '0');
			return y + '-' + m + '-' + d;
		},
		formatAmount(val) {
			if (!val && val !== 0) return '0.00';
			return Number(val).toFixed(2);
		},
		statusLabel(s) {
			var map = { '0': '待处理', '1': '开具中', '2': '已完成', '3': '失败' };
			return map[s] || '未知';
		},
		isRedInvoice(item) {
			return item.xsdjbh && item.xsdjbh.indexOf('HC') === 0;
		},
		onTabChange() {
			// tab切换时无需重新请求，使用前端过滤
		},
		statusClass(s) {
			var map = { '0': 'pending', '1': 'processing', '2': 'completed', '3': 'failed' };
			return map[s] || '';
		},
		actionBtnText(item) {
			var s = item.orderStatus;
			var fpzt = item.fpzt;
			if (s === '1') return '开具中...';
			if (s === '3') return '重新开具';
			if (s === '2') {
				if (fpzt === '1' || fpzt === '2') return '重新开票'; // 已红冲/已作废
				if (fpzt === '10') return '红冲中...'; // 红冲申请中
				return '查看发票'; // 正常
			}
			return '查看详情';
		},
		// 是否显示操作按钮：查看类入口始终显示；重新开具/重新开票需要小区启用开票
		shouldShowActionBtn(item) {
			var s = item.orderStatus;
			var fpzt = item.fpzt;
			// 重新开具（失败） / 重新开票（已红冲/已作废）受开票开关限制
			if (s === '3') return !!item.invoiceEnabled;
			if (s === '2' && (fpzt === '1' || fpzt === '2')) return !!item.invoiceEnabled;
			// 其余状态（待处理/开具中/红冲中/正常已开票）属于查看类，不受影响
			return true;
		},
		actionBtnClass(item) {
			var s = item.orderStatus;
			var fpzt = item.fpzt;
			if (s === '1') return 'btn-disabled';
			if (s === '3') return 'btn-retry';
			if (s === '2') {
				if (fpzt === '1' || fpzt === '2') return 'btn-retry';
				if (fpzt === '10') return 'btn-disabled';
				return 'btn-primary';
			}
			return 'btn-primary';
		},
		onAction(item) {
			var s = item.orderStatus;
			var fpzt = item.fpzt;
			if (s === '2') {
				if (fpzt === '1' || fpzt === '2') {
					// 已红冲/已作废 - 重新开票
					this.$router.push({
						path: '/wyfw/invoicefill',
						query: {
							id: item.def01,
							typeName: item.typeName || '',
							amount: item.jshj,
							villageId: item.villageId || '',
							type: item.def02 || ''
						}
					});
				} else if (fpzt === '10') {
					// 红冲申请中 - 不可操作
					return;
				} else {
					// 正常已开票 - 查看发票
					this.$router.push({
						path: '/wyfw/invoicedetail',
						query: { xsdjbh: item.xsdjbh, from: 'history' }
					});
				}
			} else if (s === '3') {
				// 失败 - 重新开具
				this.$router.push({
					path: '/wyfw/invoicefill',
					query: {
						id: item.def01,
						typeName: item.typeName || '',
						amount: item.jshj,
						villageId: item.villageId || '',
						type: item.def02 || ''
					}
				});
			} else if (s === '0' || s === '1') {
				// 待处理/开具中 - 查看详情
				this.$router.push({
					path: '/wyfw/invoicedetail',
					query: { xsdjbh: item.xsdjbh, from: 'history' }
				});
			}
		}
	}
}
</script>

<style lang="less" scoped>
.invoice-history {
	height: calc(100% - 50px);
	width: 100%;
	display: flex;
	background-color: #f5f5f5;
	flex-direction: column;
	align-items: center;
	overflow-y: auto;
}
.content {
	width: 100%;
	padding: 15px;
}

/* Tabs */
.invoice-tabs {
	margin-bottom: 12px;
	border-radius: 8px;
	overflow: hidden;
	background-color: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 搜索区 */
.search-section {
	background-color: #fff;
	border-radius: 12px;
	padding: 16px;
	margin-bottom: 15px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.search-row {
	display: flex;
	gap: 12px;
	margin-bottom: 12px;
}
.search-row:last-of-type {
	margin-bottom: 0;
}
.search-item {
	flex: 1;
}
.search-label {
	font-size: 13px;
	color: #666;
	margin-bottom: 6px;
	font-weight: 500;
}
.search-item .van-field {
	padding: 6px 10px;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background-color: #fafafa;
	font-size: 14px;
}
.search-btn {
	width: 100%;
	height: 40px;
	background: #00b5ff;
	color: #fff;
	border: none;
	border-radius: 8px;
	font-size: 15px;
	font-weight: 500;
	margin-top: 12px;
	cursor: pointer;
}

/* 列表 */
.history-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}
.history-item {
	background-color: #fff;
	border-radius: 12px;
	padding: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.history-header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 10px;
}
.invoice-title {
	font-size: 15px;
	font-weight: 600;
	color: #333;
	flex: 1;
	line-height: 1.4;
	margin-right: 10px;
	word-break: break-all;
}
.invoice-status {
	padding: 3px 10px;
	border-radius: 16px;
	font-size: 12px;
	font-weight: 500;
	flex-shrink: 0;
	&.pending {
		background-color: #fff3e0;
		color: #ff9800;
	}
	&.processing {
		background-color: #e3f2fd;
		color: #2196f3;
	}
	&.completed {
		background-color: #e8f5e9;
		color: #4caf50;
	}
	&.failed {
		background-color: #fce4ec;
		color: #f44336;
	}
}
.invoice-type-tag {
	padding: 3px 8px;
	border-radius: 4px;
	font-size: 11px;
	font-weight: 500;
	flex-shrink: 0;
	margin-left: 6px;
	&.red-tag {
		background-color: #fef2f2;
		color: #ef4444;
		border: 1px solid #fecaca;
	}
}
.history-info {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	font-size: 13px;
	color: #666;
	margin-bottom: 10px;
}
.info-item {
	display: flex;
	align-items: center;
}
.info-label {
	color: #999;
}
.info-value {
	color: #333;
	font-weight: 500;
}
.fail-reason {
	width: 100%;
	margin-top: 4px;
	padding-top: 8px;
	border-top: 1px dashed #fce4ec;
	line-height: 1.4;
	align-items: flex-start;
	.info-label {
		color: #f44336;
		flex-shrink: 0;
	}
	.info-value {
		color: #f44336;
		font-weight: 500;
		word-break: break-all;
	}
}
.history-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 10px;
	border-top: 1px solid #f0f0f0;
}
.invoice-date {
	font-size: 13px;
	color: #999;
}
.action-btn {
	padding: 6px 16px;
	border: none;
	border-radius: 20px;
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	&.btn-primary {
		background-color: #00b5ff;
		color: #fff;
	}
	&.btn-disabled {
		background-color: #f5f5f5;
		color: #999;
		pointer-events: none;
	}
	&.btn-retry {
		background-color: #ff9800;
		color: #fff;
	}
}

/* 空状态 & 加载 */
.empty-state {
	text-align: center;
	padding: 60px 0;
	.empty-text {
		font-size: 14px;
		color: #999;
		margin-top: 15px;
	}
}
.loading-state {
	text-align: center;
	padding: 60px 0;
}

::-webkit-scrollbar {
	display: none;
}
</style>
